import e from"./colors.js";var o={defaults:{textSize:"M",textWeight:"Normal",successTextColor:e.green[300],warningTextColor:e.orange[300],dangerTextColor:e.red[300],disabledTextColor:e.lightScale[300]}};export{o as default};
